import {css} from '@emotion/css';
import {Breakpoints, mq} from '@fo/shared/styles/mixins';

import {colours, spacing} from '@fo/shared/styles/variables';
import {RelatedArticlesBackgroundColor} from './types';

export default {
  componentWrapper: (bgColor?: RelatedArticlesBackgroundColor): string => css`
    label: relatedArticles;
    padding: ${spacing.XS};
    border: 1px solid ${colours.brand.TERTIARY};
    ${bgColor === RelatedArticlesBackgroundColor.WHITE &&
    css`
      background-color: ${colours.general.WHITE};
    `}
  `,
  title: css`
    label: relatedArticles__title;
    margin-bottom: ${spacing.M};
  `,
  linkWrap: css`
    label: relatedArticles__linkWrap;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  `,
  link: css`
    label: relatedArticles__link;
    display: block;
    margin-bottom: ${spacing.XXS};
    padding-right: ${spacing.XXS};
    width: 100%;
    ${mq(Breakpoints.TABLET)} {
      width: 50%;
    }
  `,
};
